import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { Switch } from "../ui/switch";
import { Textarea } from "../ui/textarea";
import { CalendarRange, ClipboardList, Wallet } from "lucide-react";
import { INCASSO_OPTIONS, PAGAMENTO_OPTIONS } from "../../lib/options";
import { RESOURCES, Field, Sel, SEZ } from "./fields";

export const DatiGeneraliSection = ({ evento, setEv, richiedente, setRichiedente, richiedenteOptions }) => (
  <SEZ icon={CalendarRange} title="Dati Generali">
    <div className="md:col-span-2">
      <Field label="Referente Operativo Nexus" value={evento.referente_nexus || ""} onChange={(v) => setEv("referente_nexus", v)} testid="ev-referente-nexus" placeholder="Precompilato dal campo Operatore C.O. del tuo profilo" />
    </div>
    <Field label="Denominazione evento/manifestazione" value={evento.denominazione} onChange={(v) => setEv("denominazione", v)} testid="ev-denominazione" />
    <Field label="Tipo evento/manifestazione" value={evento.tipo} onChange={(v) => setEv("tipo", v)} testid="ev-tipo" />
    <div className="md:col-span-2">
      <Sel label="Richiedente (uso interno, non compare nel PDF)" value={richiedente} onChange={setRichiedente} options={richiedenteOptions} testid="ev-richiedente" />
    </div>
    <div className="md:col-span-2">
      <Field label="Luogo dell'evento/manifestazione" value={evento.luogo} onChange={(v) => setEv("luogo", v)} testid="ev-luogo" />
    </div>
    <Field label="Data e ora inizio" type="datetime-local" value={evento.data_ora_inizio} onChange={(v) => setEv("data_ora_inizio", v)} testid="ev-inizio" />
    <Field label="Data e ora fine" type="datetime-local" value={evento.data_ora_fine} onChange={(v) => setEv("data_ora_fine", v)} testid="ev-fine" />
  </SEZ>
);

const RisorseList = ({ risorse, setRis }) => (
  <div className="space-y-2">
    {RESOURCES.map((r) => {
      const item = risorse[r.key] || { enabled: false, qty: 1 };
      return (
        <div key={r.key} className="flex items-center gap-3 rounded-md border border-slate-200 px-3 py-2">
          <Switch data-testid={`ev-res-${r.key}-toggle`} checked={item.enabled} onCheckedChange={(v) => setRis(r.key, { enabled: !!v })} />
          <span className="text-sm font-medium text-slate-700 flex-1">{r.label}</span>
          <Input data-testid={`ev-res-${r.key}-qty`} type="number" min={1} value={item.qty} disabled={!item.enabled}
            onChange={(e) => setRis(r.key, { qty: Math.max(1, parseInt(e.target.value || "1", 10)) })} className="w-24 h-9" placeholder="Unità" />
          <span className="text-xs text-slate-400 w-10">unità</span>
        </div>
      );
    })}
  </div>
);

export const DatiOperativiSection = ({ evento, setEv, setRis }) => (
  <SEZ icon={ClipboardList} title="Dati Operativi">
    <div className="md:col-span-2">
      <Label className="nx-label mb-2 block">Risorse richieste</Label>
      <RisorseList risorse={evento.risorse} setRis={setRis} />
    </div>
    <div className="md:col-span-2">
      <Field label="Luogo di stazionamento" value={evento.luogo_stazionamento} onChange={(v) => setEv("luogo_stazionamento", v)} testid="ev-stazionamento" />
    </div>
    <Field label="Referente dell'evento/manifestazione" value={evento.referente} onChange={(v) => setEv("referente", v)} testid="ev-referente" />
    <Field label="Telefono del referente" value={evento.telefono_referente} onChange={(v) => setEv("telefono_referente", v)} testid="ev-telefono-referente" />
  </SEZ>
);

export const ContabilitaEventoSection = ({ contabilita, setContabilita }) => {
  const upd = (k) => (v) => setContabilita({ ...contabilita, [k]: v });
  return (
    <SEZ icon={Wallet} title="Contabilità e Note">
      <Field label="Importo Servizio (€)" value={contabilita.importo} onChange={upd("importo")} testid="ev-con-importo" />
      <Field label="Importo Totale (€)" value={contabilita.importo_totale} onChange={upd("importo_totale")} testid="ev-con-importo-totale" />
      <Sel label="Incasso" value={contabilita.incasso} onChange={upd("incasso")} options={INCASSO_OPTIONS} testid="ev-con-incasso" />
      <Sel label="Modalità Pagamento" value={contabilita.modalita_pagamento} onChange={upd("modalita_pagamento")} options={PAGAMENTO_OPTIONS} testid="ev-con-pagamento" />
      <Field label="Fee Nexus (€)" value={contabilita.fee_nexus} onChange={upd("fee_nexus")} testid="ev-con-fee" />
      <Field label="Codice Fiscale" value={contabilita.codice_fiscale} onChange={upd("codice_fiscale")} testid="ev-con-cf" />
      <div className="md:col-span-2">
        <Label className="nx-label">Note Operative</Label>
        <Textarea data-testid="ev-con-note" value={contabilita.note} onChange={(e) => upd("note")(e.target.value)} className="mt-1.5" rows={3} />
      </div>
    </SEZ>
  );
};
